/** Keep only subscription entries that carry some data (a status or a brand); never render an empty card. */
export function withSubscriptionData<T extends { status?: string; brand?: string }>(list: unknown): T[] {
  if (!Array.isArray(list)) return [];
  return list.filter(
    (s): s is T => typeof s === 'object' && s !== null && (!!(s as T).status || !!(s as T).brand),
  );
}
